import { EditMode } from './edit-mode';

export type EditModeMenuItemId =
  | 'crop'
  | 'resize'
  | 'rotate'
  | 'filter'
  | 'watermark'
  | 'deskew'
  | 'animation'
  | 'merge'
  | 'object-detection';

export interface EditModeMenuItem {
  id: EditModeMenuItemId;
  titleKey: string;
  icon: string;
  mode: EditMode;
  helpKey: string;
  chipKeys: readonly string[];
}

export const EDIT_MODE_MENU_ITEMS: EditModeMenuItem[] = [
  {
    id: 'crop',
    titleKey: 'MAIN_MENU.BUTTONS.CROP',
    icon: 'crop',
    mode: EditMode.Crop,
    helpKey: 'EDITOR.TOP_PANEL.HELP.MODES.CROP',
    chipKeys: ['EDITOR.CROP.SQUARE', 'EDITOR.CROP.CUSTOM'],
  },
  {
    id: 'resize',
    titleKey: 'MAIN_MENU.BUTTONS.RESIZE',
    icon: 'resize',
    mode: EditMode.Resize,
    helpKey: 'EDITOR.TOP_PANEL.HELP.MODES.RESIZE',
    chipKeys: [
      'EDITOR.CONTROLS.WIDTH',
      'EDITOR.CONTROLS.HEIGHT',
      'EDITOR.CONTROLS.X_SCALE',
      'EDITOR.CONTROLS.Y_SCALE',
      'EDITOR.CONTROLS.LOCK_ASPECT_RATIO',
    ],
  },
  {
    id: 'rotate',
    titleKey: 'MAIN_MENU.BUTTONS.ROTATE',
    icon: 'rotate',
    mode: EditMode.Rotate,
    helpKey: 'EDITOR.TOP_PANEL.HELP.MODES.ROTATE',
    chipKeys: ['EDITOR.CONTROLS.FLIP', 'EDITOR.CONTROLS.ROTATE', 'EDITOR.ROTATE.FIT', 'EDITOR.ROTATE.CUT'],
  },
  {
    id: 'filter',
    titleKey: 'MAIN_MENU.BUTTONS.FILTER',
    icon: 'filter',
    mode: EditMode.Filter,
    helpKey: 'EDITOR.TOP_PANEL.HELP.MODES.FILTER',
    chipKeys: [
      'FILTERS.GAUSSIAN_BLUR.TITLE',
      'FILTERS.SHARPEN.TITLE',
      'FILTERS.MEDIAN.TITLE',
      'FILTERS.BILATERAL_SMOOTHING.TITLE',
    ],
  },
  {
    id: 'watermark',
    titleKey: 'MAIN_MENU.BUTTONS.WATERMARK',
    icon: 'watermark',
    mode: EditMode.Watermark,
    helpKey: 'EDITOR.TOP_PANEL.HELP.MODES.WATERMARK',
    chipKeys: [
      'EDITOR.WATERMARK.TEXT',
      'EDITOR.WATERMARK.FONT_NAME',
      'EDITOR.WATERMARK.TEXT_COLOR',
      'EDITOR.WATERMARK.FONT_SIZE',
      'EDITOR.WATERMARK.ROTATION',
    ],
  },
  {
    id: 'deskew',
    titleKey: 'MAIN_MENU.BUTTONS.DESKEW',
    icon: 'deskew',
    mode: EditMode.Deskew,
    helpKey: 'EDITOR.TOP_PANEL.HELP.MODES.DESKEW',
    chipKeys: [
      'EDITOR.DESKEW.RESIZE_PROPORTIONALLY',
      'EDITOR.DESKEW.TRANSPARENT_BACKGROUND',
      'EDITOR.DESKEW.BACKGROUND_COLOR',
    ],
  },
  {
    id: 'animation',
    titleKey: 'MAIN_MENU.BUTTONS.ANIMATION',
    icon: 'animation',
    mode: EditMode.Animation,
    helpKey: 'EDITOR.TOP_PANEL.HELP.MODES.ANIMATION',
    chipKeys: [
      'EDITOR.ANIMATION.WIDTH',
      'EDITOR.ANIMATION.HEIGHT',
      'EDITOR.ANIMATION.LOOP_COUNT',
      'EDITOR.ANIMATION.FRAME_DELAY',
    ],
  },
  {
    id: 'merge',
    titleKey: 'MAIN_MENU.BUTTONS.MERGE',
    icon: 'merge',
    mode: EditMode.Merge,
    helpKey: 'EDITOR.TOP_PANEL.HELP.MODES.MERGE',
    chipKeys: [
      'EDITOR.MERGE.LAYOUT',
      'EDITOR.MERGE.SPACING',
      'EDITOR.MERGE.BORDER_WIDTH',
      'EDITOR.MERGE.BACKGROUND_COLOR',
    ],
  },
  {
    id: 'object-detection',
    titleKey: 'MAIN_MENU.BUTTONS.OBJECT_DETECTION',
    icon: 'object_detection',
    mode: EditMode.ObjectDetection,
    helpKey: 'EDITOR.TOP_PANEL.HELP.MODES.OBJECT_DETECTION',
    chipKeys: ['EDITOR.OBJECT_DETECTION.DETECT', 'EDITOR.OBJECT_DETECTION.DOWNLOAD_JSON'],
  },
] as EditModeMenuItem[];

export function getEditModeMenuItem(mode: EditMode | null | undefined): EditModeMenuItem | null {
  return EDIT_MODE_MENU_ITEMS.find(item => item.mode === mode) ?? null;
}
